import { useOutletContext } from 'react-router-dom';
import { Users, FileText, Mail, Rocket, TrendingUp, Calendar } from 'lucide-react';

export default function AdminDashboard() {
  const { stats } = useOutletContext();

  const cards = [
    { label: 'Total Users', value: stats?.total_users ?? '-', icon: Users, color: 'text-cyan' },
    { label: 'Total Notes', value: stats?.total_notes ?? '-', icon: FileText, color: 'text-green-400' },
    { label: 'Contact Messages', value: stats?.total_contacts ?? '-', icon: Mail, color: 'text-gold' },
    { label: 'Beta Signups', value: stats?.total_beta_signups ?? '-', icon: Rocket, color: 'text-purple-400' },
    { label: 'New Users Today', value: stats?.new_users_today ?? '-', icon: TrendingUp, color: 'text-emerald-400' },
    { label: 'Notes This Week', value: stats?.notes_this_week ?? '-', icon: Calendar, color: 'text-sky-400' },
  ];

  return (
    <div>
      <h1 className="font-heading text-3xl text-white mb-8" data-testid="admin-dashboard-title">Admin Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
        {cards.map(card => (
          <div key={card.label} className="glass rounded-2xl p-6" data-testid={`stat-${card.label.toLowerCase().replace(/ /g, '-')}`}>
            <div className="flex items-center justify-between mb-3">
              <span className="text-slate-400 text-sm">{card.label}</span>
              <card.icon size={20} className={card.color} />
            </div>
            <p className="text-3xl font-bold text-white">{card.value}</p>
          </div>
        ))}
      </div>

      {/* Recent Contact Messages */}
      {stats?.recent_contacts?.length > 0 && (
        <div className="glass rounded-2xl p-6">
          <h2 className="text-lg text-white font-medium mb-4">Recent Contact Messages</h2>
          <div className="space-y-3">
            {stats.recent_contacts.map(c => (
              <div key={c.id} className="flex items-start gap-4 p-3 bg-navy-900/50 rounded-xl">
                <Mail size={16} className="text-gold mt-1 flex-shrink-0" />
                <div className="min-w-0">
                  <p className="text-white text-sm font-medium truncate">{c.name} — {c.subject || 'No subject'}</p>
                  <p className="text-slate-400 text-xs truncate">{c.message}</p>
                  <p className="text-slate-500 text-xs mt-1">{new Date(c.created_at).toLocaleString()}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
